import { error_message } from "../../../../constants/Errors";

export const validateDates = (errorToast, notification) => {
  const startDate: Date = new Date(notification?.start_date);
  const endDate: Date = new Date(notification?.end_date);

  if (startDate > endDate) {
    errorToast(error_message.notification.start_data);
    return false;
  } else {
    return true;
  }
};
